module.exports = __webpack_public_path__ + "static/images/cards-close.94f339c7dbdb0c12cf8e43ae8db92231.svg";